import { mapState } from 'vuex';

export const fixedTopBarMixin = {
    data: function () {
        return {
            window: {
                height: 0,
            },
            facebookBrowserOnIosDetected: false,
            instagramBrowserOnIosDetected: false,
            underVideoFacebookBrowser: false,
            facebookHackActivated: false,
        };
    },
    beforeDestroy() {
        if (this.facebookBrowserOnIosDetected) {
            window.removeEventListener('scroll', this.handleScroll);
        }
    },
    mounted() {
        this.detectFacebookBrowserOnIos();
        this.detectInstagramBrowserOnIos();

        if (this.facebookBrowserOnIosDetected) {
            this.updateWindowHeight();

            this.handleScroll();
            window.addEventListener('scroll', this.handleScroll);
            window.App.isFacebook = true;
        }

        if (this.instagramBrowserOnIosDetected) {
            window.App.isInstagram = true;
        }
    },
    computed: {
        ...mapState(['salesButtonSeen', 'defaultPaymentMethod']),
    },
    methods: {
        handleScroll() {
            /*
             *  For reference in following comments.
             *  Facebook browser has two types.
             *  - "Normal Facebook Browser" (Opens as a popup, when you click on link)
             *  - "Under video browser" (Shows up right under video ad while it's playing)
             */

            /*
             * Update window height prop on scroll to handle issue where facebook on load
             * sometimes return random height resulting in wrong appearence
             */
            this.updateWindowHeight();

            this.checkFacebookBrowserType();

            /*
             * Facebooks "Under video browser" case has some bug's that we are handeling in this method.
             * Bug 1. - On scroll viewport is pushed outside of screen resulting in popup beeing hidden.
             * Bug 2. - If user clicks facebooks back button from the middle of the page user get's
             *          pushed to top with black screen as video and nothing in top part clickable.
             *          If we add cehckout button there then it's not clickable.
             * Bug 3. - If user had scrolled back to video and buy button is active in top bar then
             *          if user clicks it. Keyboard is shown but the input field is not visible.
             *
             * Check if we need to active the hack
             * 1. "this.facebookBrowserDetected" returns true if facebook browser is detected.
             * 2. "underVideoFacebookBrowser" we only run this hack if it's "Under video browser" case
             * 3. "window.scrollY > 53" we only activate the hack when user has scrolled below the popup.
             */

            if (this.underVideoFacebookBrowser && window.scrollY > 53) {
                /*
                 *  Fix for "bug 2" and "bug 3".
                 *  If user has scrolled to sales button and then back to top we show back timer
                 *  instead of button. Then if user again starts to scroll down sales button shows
                 *  up again.
                 */
                this.facebookHackActivated = true;
                // Set up facebook-scrolled class that handeles this HACK in CSS..
                this.addClass(document.getElementById('timer-top-banner'), 'facebook-scrolled');
            } else if (this.underVideoFacebookBrowser && window.scrollY <= 53) {
                // Remove facebook-scrolled class when no need for facebook browser hack.
                this.removeClass(document.getElementById('timer-top-banner'), 'facebook-scrolled');
            }
        },

        hideTimerBanner: function () {
            this.addClass(document.getElementById('timer-top-banner'), 'hide-top-bar');
            this.addClass(document.getElementById('timer-top-banner-spacer'), 'hide-top-bar');
        },
        updateWindowHeight() {
            this.window.height = window.innerHeight;
        },
        checkFacebookBrowserType() {
            /*
             *   Here we detect the "Normal Facebook Browser" case.
             *   This case always han a specific heights for each device.
             *   We detect that "Normal Facebook Browser" is active if heights match.
             */
            if (
                // iPhone 5
                this.window.height === 568 ||
                // iPhone 8
                this.window.height === 667 ||
                // iPHone 8 PLUS
                this.window.height === 736 ||
                // iPhone XS MAX && iPhone XR
                this.window.height === 896 ||
                // iPhone XS
                this.window.height === 812 ||
                // iPhone 12
                this.window.height === 844 ||
                // iPhone 12 Pro MAX
                this.window.height === 926 ||
                // iPhone 14 Pro
                this.window.height === 852 ||
                // iphone 14 Pro MAX
                this.window.height === 932 ||
                // iPad Air 2
                this.window.height === 1024 ||
                // iPad Pro 12.9-inch
                this.window.height === 1366 ||
                // iPad 10 inch
                this.window.height === 834
            ) {
                this.underVideoFacebookBrowser = true;
                window.App.underVideoFacebookBrowser = true;
            }
        },
        detectFacebookBrowserOnIos() {
            var ua = navigator.userAgent || navigator.vendor || window.opera;
            this.facebookBrowserOnIosDetected =
                ua.indexOf('FBAN') > -1 ||
                (ua.indexOf('FBAV') > -1 && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
        },
        detectInstagramBrowserOnIos() {
            var ua = navigator.userAgent || navigator.vendor || window.opera;
            this.instagramBrowserOnIosDetected = ua.indexOf('Instagram') > -1 ? true : false;
        },
        addClass: function (el, className) {
            if (el.classList) el.classList.add(className);
            else if (!this.hasClass(el, className)) el.className += ' ' + className;
        },
        removeClass: function (el, className) {
            if (el.classList) el.classList.remove(className);
            else if (this.hasClass(el, className)) {
                var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
                el.className = el.className.replace(reg, ' ');
            }
        },
        hasClass(el, className) {
            return el.classList
                ? el.classList.contains(className)
                : new RegExp('\\b' + className + '\\b').test(el.className);
        },
        scrollToPaymentBlock() {
            const offset = $('.buy-box').offset().top;

            window.$('html, body').animate(
                {
                    scrollTop: offset - window.innerHeight / 2 + $('.buy-box').height() / 2,
                },
                300,
            );
        },
    },
};
